export default __webpack_public_path__ + "static/laser_engraving2-bcff5ceccf796bf1fce0b38579798d0b.jpg";